import useLanguage from '@op/hooks/useLanguage';
import useTabHistory from '@op/hooks/useTabHistory';
import { parseReportOwnerQuery } from '@op/components/ReportPermission';
import { useInitBuriedPointInfo } from '@op/operationLog/buriedPoint';
import { KeywordAnalysis, KeywordAnalysisList } from '@op/operationLog/pages';
import { useCallback, useMemo, useState } from 'react';
import { useLocation } from 'umi';

export default function useKeywordTopicPage() {
  const { formatMessage } = useLanguage();
  const location = useLocation<{ query?: { owner?: string } }>();
  const { tab: activeId, onActive } = useTabHistory({
    defaultValue: 'createAnalysis',
  });

  const initialOwner = useMemo(
    () => parseReportOwnerQuery(location?.query?.owner),
    [location?.query?.owner],
  );

  // 用于存储从 KeywordFilter 传递的 secondSegment
  const [initialSecondSegment, setInitialSecondSegment] = useState<
    string | undefined
  >();

  // 切换到 savedAnalysisList tab，并设置 secondSegment
  const handleChangeTab = useCallback(
    (secondSegment?: string) => {
      setInitialSecondSegment(secondSegment);
      onActive({ id: 'savedAnalysisList' });
    },
    [onActive],
  );

  useInitBuriedPointInfo({
    buriedPoint:
      activeId === 'savedAnalysisList' ? KeywordAnalysisList : KeywordAnalysis,
  });

  const tabs = useMemo(
    () => [
      {
        id: 'createAnalysis',
        label: formatMessage({
          id: 'Create Analysis',
        }),
      },
      {
        id: 'savedAnalysisList',
        label: formatMessage({
          id: 'Saved Analysis List',
        }),
      },
    ],
    [formatMessage],
  );

  return {
    tabs,
    handleChangeTab,
    initialSecondSegment,
    initialOwner,
    activeId,
    onActive,
    formatMessage,
  };
}
